<div class="container">
  <div class="header">
    <div class="title">
      <span fiTranslation="REQUEST_DETAIL_HEADER_TAGS_ACTION_ADD_TAG"></span>
    </div>
    <button (click)="onClosePopup()">
      <img alt="Close" src="/assets/icons/close-icon.svg">
      <span class="u-hidden-visually" fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </button>
  </div>

  <fi-input
    [options]="shownPossibleTags"
    [namePropertyPath]="'Text'"
    [valuePropertyPath]="'Text'"
    labelKey="REQUEST_DETAIL_OVERLAY_TAGS_LABEL"
    placeholderKey="REQUEST_DETAIL_HEADER_ADD_TAG_PLACEHOLDER"
    [maxLength]="40"
    [maxMenuHeight]="200"
    [enableSearch]="true"
    [clearOnEnterOrSelect]="true"
    type="SELECT"
    (onChange)="onAddTag($event)"
    (onEnterPressed)="onAddTag($event)"
    >

  </fi-input>

  <div class="tags-cont">
    <div class="create-tag-btn-container">
      @for (tag of tags; track tag; let i = $index) {
        <div class="tag">
          <span>{{ tag.Text }}</span>
          @if (tag.Owned) {
            <mat-icon (click)="tags.splice(i, 1); updateTags(); actionHelper.notifyAboutEdit();">close</mat-icon>
          }
        </div>
      }
      @if (tags?.length) {
        <button (click)="clearAllTags()" class="clear-btn">
          <span fiTranslation="REQUEST_DETAIL_HEADER_TAGS_ACTION_CLEAR_TAGS"></span>
        </button>
      }
    </div>
  </div>


  <div class="button-row">
    <button (click)="onSubmit()" [disabled]="!tagsToDelete.length && !tagsToAdd.length">
      <span class="btn-title" [replaceKeys]="true" [fiTranslation]="'%REQUEST_DETAIL_HEADER_ADD_TAG% (' + tags.length + ')'"></span>
    </button>
  </div>

</div>

